module.exports = __webpack_public_path__ + "static/egyptian-fitted-sheet-grey-1-2ff373ee607b623bdd9a670117d86dc3.webp";